export const SESSION_INACTIVITY_TIMEOUT = 5 * 60 * 1000;
export const SESSION_WARNING_TIME = 2 * 60 * 1000;
export const SESSION_MAX_AGE = 8 * 60 * 60 * 1000;
